export default __webpack_public_path__ + "static/media/sharePoint.70eec6fb.svg";